// extracted by mini-css-extract-plugin
export default {"hourListOuterContainer":"p_GXm9zP5IanE4n1zvGg-ContactInfoHours-hourListOuterContainer","hourList__heading":"hSOm2nTNNj528GVCwqJp-ContactInfoHours-hourList__heading"};